import { applyMiddleware, combineReducers, compose, createStore as _createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { stateReducer } from '../reducers/state';
import { changeViewReducer } from '../reducers/view';
import { changeTabReducer } from '../reducers/tabs';
import { changeFlowReducer } from '../reducers/flow';
import { changeLoginReducer } from '../reducers/login';
import { checkEmailReducer, authenticateReducer, restoreReducer, resetReducer, changePasswordReducer, twoFactorReducer } from '../reducers/authentication';
import { registerReducer, sendSmsReducer, confirmPhoneReducer, professionalUserReducer } from '../reducers/registration';
import { authenticateReducer as socialAuthenticateReducer, createReducer as socialCreateReducer, mergeReducer as socialMergeReducer, expandReducer as socialExpandReducer, phoneReducer as socialPhoneReducer, emailReducer as socialEmailReducer } from '../reducers/social';
import { authenticateByTokenReducer, changePhoneReducer, checkPhoneReducer, registerOrAuthorizeByTokenReducer, registerOrAuthorizeReducer, sendValidationCodeReducer, autosubmitEnabledReducer } from '../reducers/phoneAuth';
import { agreementReducer } from '../reducers/agreement';
import { autoFocusDisabledReducer } from '../reducers/autoFocusDisabled';
import { sourceReducer } from '../reducers/source';
export function createStore(options) {
  var reducer = reduceReducers(stateReducer, combineReducers({
    view: changeViewReducer,
    activeTab: changeTabReducer,
    activeFlow: changeFlowReducer,
    login: changeLoginReducer,
    phoneAuth: reduceReducers(sendValidationCodeReducer, registerOrAuthorizeReducer, changePhoneReducer, checkPhoneReducer, authenticateByTokenReducer, registerOrAuthorizeByTokenReducer, autosubmitEnabledReducer),
    authentication: reduceReducers(checkEmailReducer, changePasswordReducer, authenticateReducer, twoFactorReducer, restoreReducer, resetReducer),
    registration: reduceReducers(registerReducer, sendSmsReducer, confirmPhoneReducer, professionalUserReducer),
    social: reduceReducers(socialAuthenticateReducer, socialPhoneReducer, socialEmailReducer, socialCreateReducer, socialMergeReducer, socialExpandReducer),
    agreement: agreementReducer,
    autoFocusDisabled: autoFocusDisabledReducer,
    // добавлен в рамках эксперимента AUD-1403, по завершению будет удален
    isRememberAccountsFlow: function isRememberAccountsFlow(state) {
      return state || false;
    },
    source: sourceReducer
  }));
  var composeEnhancers = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  var context = options.context;
  var enhancers = composeEnhancers(applyMiddleware(thunkMiddleware.withExtraArgument(context)));
  if (options.preloadedState) {
    return _createStore(reducer, options.preloadedState, enhancers);
  } else {
    return _createStore(reducer, enhancers);
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function reduceReducers() {
  for (var _len = arguments.length, reducers = new Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }
  return function (prevState, action) {
    return reducers.reduce(function (newState, reducer) {
      return reducer(newState, action);
    }, prevState);
  };
}